<div class="p-5 pt-0 text-primary-darkest" *ngIf="user">
  <div class="mb-5 hidden items-center space-x-3 lg:flex">
    <span class="mt-1 h-1 w-12 bg-primary-md-dark"></span>
    <h1 class="relative text-2xl font-semibold lg:text-3xl">Happy Pay</h1>
  </div>
  <div class="mx-auto w-full justify-between sm:max-w-none lg:mx-0 lg:flex">
    <div
      class="relative mx-auto mb-5 w-full overflow-hidden rounded-xl bg-primary-md-dark p-4 text-white md:max-w-xs lg:mx-0 lg:mb-0">
      <picture class="absolute top-0 left-0 h-full w-full">
        <img
          class="h-full w-full object-cover object-center"
          src="assets/images/happy-pay/bg-happy-pay-card-lg.png"
          alt="" />
      </picture>
      <div class="relative font-bold">
        <span>Happy Pay Balance </span>
        <div class="relative">
          <div class="mt-4 sm:mt-3">
            <div class="text-2xl">
              {{ user.happy_pay.current_balance | fcCurrency }}
            </div>
            <div class="mt-4 mb-3 text-sm font-normal sm:mt-1">
              Account No: {{ user.happy_pay.account_no }}
            </div>
          </div>
          <picture
            class="absolute -bottom-3 right-0 h-12 w-12 rounded-full bg-white p-2">
            <img src="assets/images/logo-sm.png" alt="logo beautybook" />
          </picture>
        </div>
      </div>
    </div>
    <div
      class="mx-auto flex max-w-sm justify-center space-x-3 lg:mx-0 lg:max-w-none lg:items-end">
      <div class="w-full">
        <button
          (click)="onHappyPayWithDrawal()"
          type="button"
          class="w-full rounded-md border border-primary-darkest px-5 py-1 duration-300 ease-in-out hover:-translate-y-1 hover:bg-primary-darkest hover:text-white lg:w-36">
          Withdrawal
        </button>
      </div>
      <div class="w-full">
        <button
          type="button"
          (click)="onHappyPayTopup()"
          class="w-full items-center rounded-md border border-primary-darkest bg-primary-darkest px-5 py-1 text-white duration-300 ease-in-out hover:-translate-y-1 lg:w-36">
          <fa-icon [icon]="faSquarePlus"></fa-icon>
          Top Up
        </button>
      </div>
    </div>
  </div>
  <div class="mt-6 rounded-lg lg:border lg:border-primary-main lg:p-5">
    <swiper
      class="mySwiper flex space-x-5 text-primary-md-dark"
      [slidesPerView]="'auto'"
      [spaceBetween]="15">
      <ng-template swiperSlide class="w-auto" *ngFor="let nav of happyPayNavs">
        <button
          type="button"
          class="rounded-md border border-primary-md-dark bg-primary-lightest px-2 py-1 text-sm duration-200 ease-in-out hover:bg-primary-md-dark hover:text-white"
          [routerLink]="[nav.link]"
          routerLinkActive="bg-primary-md-dark text-white">
          {{ nav.name }}
        </button>
      </ng-template>
    </swiper>
    <div class="mt-5">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
